// TikTok Pixel for the creator recruitment funnel. Loads only when
// REACT_APP_TIKTOK_PIXEL_ID is set. Events carry no personal data.
const PIXEL_ID = process.env.REACT_APP_TIKTOK_PIXEL_ID;
let loaded = false;

export function loadTikTokPixel() {
  if (!PIXEL_ID || loaded || typeof window === "undefined") return;
  loaded = true;
  /* eslint-disable */
  !(function (w, d, t) {
    w.TiktokAnalyticsObject = t;
    var ttq = (w[t] = w[t] || []);
    ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"];
    ttq.setAndDefer = function (t, e) {
      t[e] = function () {
        t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
      };
    };
    for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    ttq.load = function (e, n) {
      var r = "https://analytics.tiktok.com/i18n/pixel/events.js";
      ttq._i = ttq._i || {};
      ttq._i[e] = [];
      ttq._i[e]._u = r;
      ttq._t = ttq._t || {};
      ttq._t[e] = +new Date();
      ttq._o = ttq._o || {};
      ttq._o[e] = n || {};
      var s = d.createElement("script");
      s.type = "text/javascript";
      s.async = !0;
      s.src = r + "?sdkid=" + e + "&lib=" + t;
      var a = d.getElementsByTagName("script")[0];
      a.parentNode.insertBefore(s, a);
    };
    ttq.load(PIXEL_ID);
    ttq.page();
  })(window, document, "ttq");
  /* eslint-enable */
}

export function ttTrack(event, params = {}) {
  try {
    if (PIXEL_ID && window.ttq) window.ttq.track(event, { content_type: "product", content_id: "creator_partner_program", ...params });
  } catch {}
}
